<div
  class="row"
  id="scheduled-payments-component"
  [ngClass]="{ 'sidebar-present': sidebarPresent }"
>
  <div class="column twelve">
    @if (!tableOnly) {
      <p dsContent [contentPath]="'billing.manageOneTimePaymentText'"></p>
    }

    @if (!!rows.length) {
      <ngx-datatable
        dsTableResizeWatcher
        #scheduledPaymentsTable
        class="none md-block"
        [ngClass]="cssClasses"
        [cssClasses]="{
          pagerLeftArrow: 'icon-chevron-left',
          pagerRightArrow: 'icon-chevron-right',
          pagerPrevious: 'icon-arrow-left-double',
          pagerNext: 'icon-arrow-right-double'
        }"
        [rows]="rows"
        [columns]="columns"
        [columnMode]="'force'"
        [headerHeight]="tableOnly ? 0 : 60"
        [rowHeight]="'auto'"
        [selectionType]="''"
        [scrollbarH]="true"
        [limit]="5"
        [footerHeight]="footerHeight"
        (page)="onCloseRow()"
      >
        <ngx-datatable-row-detail [rowHeight]="'auto'">
          <ng-template let-row="row" let-expanded="expanded" ngx-datatable-row-detail-template>
            @if (expanded && selectedScheduledPayment) {
              <div>
                <ds-bill-account-payments-scheduled-bundle
                  [selectedScheduledPayment]="selectedScheduledPayment"
                  (onCloseEvent)="onCloseRow(row)"
                >
                </ds-bill-account-payments-scheduled-bundle>
              </div>
            }
          </ng-template>
        </ngx-datatable-row-detail>
      </ngx-datatable>
    }

    <ds-table
      class="block md-none"
      [ngClass]="{ 'mobile-only': sidebarPresent }"
      [rows]="rows"
      [columns]="columns"
      [headerHeight]="60"
      [tableClasses]="'action-row'"
    >
    </ds-table>

    <!-- no scheduled payments -->
    @if (!rows.length && (dataLoading | async) === false) {
      <div>
        <p
          data-cy="noScheduledPaymentsText"
          class="pad-bottom-20"
          dsContent
          [contentPath]="'billing.noScheduledPaymentsP1'"
          applicationDependentCopy="true"
        ></p>
      </div>
    }

    @if (!tableOnly) {
      <button
        ds-button
        authCheck
        [permissionName]="'makemyacctpayment_walkthrough'"
        [checkAction]="'disable'"
        class="-offset"
        [disabled]="disableAddButton"
        (click)="addScheduledPaymentClick()"
        aria-label="Schedule a Payment"
        data-cy="schedulePaymentButton"
      >
        Schedule a Payment
      </button>
    }

    @if (dataLoading | async) {
      <ds-localized-spinner
        class="block pad-bottom-20"
        [dataLoading]="dataLoading | async"
        [loadingMessage]="'Looking for scheduled payments...'"
      ></ds-localized-spinner>
    }
  </div>
</div>

<ng-template #headerCellTpl let-column="column">
  @if (!tableOnly) {
    <div class="header-cell table-header-cell-wrapper">
      <span
        [ngClass]="{
          'none lg-block': column?.name && column?.shortName,
          block: column?.name && !column?.shortName
        }"
        >{{ column?.name }}</span
      >
      @if (!!column?.shortName) {
        <span class="block lg-none">{{ column?.shortName }}</span>
      }
    </div>
  }
</ng-template>

<ng-template #scheduledReferenceCellTpl let-row="row">
  <div class="scheduled-reference-cell ds-table-body-cell-header-wrapper">
    <div class="block md-none ds-table-body-cell-header">
      <h3 class="margin-0" title="{{ row?.singleAccount?.singleNickName }}">
        <a
          [dsRouterLink]="[
            billingPaths.BILLING_DETAIL_PAGE,
            row?.singleAccount?.singleAccountNumber
          ]"
          >{{ row?.singleAccount?.singleNickName }}</a
        >
      </h3>
    </div>

    <div class="none md-flex table-body-cell-label-content expandable-cell">
      <span>
        @if (!row?.singleAccount?.singleAccountNumber) {
          <a (click)="onScheduleNameClickEvent(row)">
            <span class="h3 fill" title="{{ row?.singleAccount?.singleNickName }}">{{
              row?.singleAccount?.singleNickName
            }}</span>
          </a>
        }
        @if (row?.singleAccount?.singleAccountNumber) {
          <div>
            <a
              class="h3 fill"
              title="{{ row?.singleAccount?.singleNickName }}"
              [dsRouterLink]="[
                billingPaths.BILLING_DETAIL_PAGE,
                row?.singleAccount?.singleAccountNumber
              ]"
              >{{ row?.singleAccount?.singleNickName }}</a
            >
          </div>
        }
      </span>
    </div>
  </div>
</ng-template>

<ng-template #paymentDetailsCellTpl let-row="row">
  <div class="payment-details-cell table-body-cell-label-content expandable-cell">
    <span>
      <div class="flex items-align">
        {{ row?.paymentDetails?.totalPaymentAmount | currencyUSD }}
      </div>
      <div class="due-date-cell">
        <p class="margin-0 due-date-cell-date">
          {{ row?.paymentDetails?.receivedDate | dateOutFormat: 'MM/DD/YY' }}
        </p>
      </div>
    </span>
  </div>
</ng-template>

<ng-template #paymentAccountCellTpl let-row="row" let-expanded="expanded">
  <div class="payment-account-cell">
    @if (!!row.paymentAccount) {
      <ds-payment-method-block
        class="cell-component"
        [rowExpanded]="expanded"
        [paymentAccount]="row.paymentAccount"
      >
      </ds-payment-method-block>
    }
    @if (!row.paymentAccount) {
      <ds-payment-method-block
        class="cell-component"
        [rowExpanded]="expanded"
        [paymentType]="row.paymentType"
        [nickName]="row.paymentAccountNickName"
      >
      </ds-payment-method-block>
    }
  </div>
</ng-template>

<ng-template #editCellTpl let-row="row" let-expanded="expanded" let-rowIndex="rowIndex">
  @if (!!row && !tableOnly) {
    <div class="edit-cell table-body-cell-label-content expandable-cell">
      <div class="flex md-none datatable-body-cell-label-actions mobile-actions">
        <!-- Mobile view - swap order -->
        <button
          ds-button
          authCheck
          [permissionName]="'editmyacctpayment_walkthrough'"
          [checkAction]="'disable'"
          class="-outline-white margin-right-12"
          aria-label="Edit"
          (click)="onEditEvent(row)"
        >
          Edit
        </button>
        <a
          authCheck
          [permissionName]="'deletemyacctpayment'"
          [checkAction]="'hide'"
          href="javascript:void(0);"
          class="error-600-text caption"
          title="Delete this scheduled payment"
          data-cy="billAccountDeleteScheduledPayment"
          (click)="onDeleteEvent(row)"
        >
          Delete
        </a>
      </div>
      @if (!expanded) {
        <div class="none md-flex datatable-body-cell-label-actions desktop-actions">
          <!-- Desktop View -->
          <a
            authCheck
            [permissionName]="'deletemyacctpayment'"
            [checkAction]="'hide'"
            href="javascript:void(0);"
            class="error-600-text caption"
            title="Delete this scheduled payment"
            (click)="onDeleteEvent(row)"
            data-cy="billAccountDeleteScheduledPaymentLink"
          >
            Delete
          </a>
          <button
            ds-button
            authCheck
            [permissionName]="'editmyacctpayment_walkthrough'"
            [checkAction]="'disable'"
            class="-outline-white"
            aria-label="Edit"
            data-cy="editScheduledPaymentButton"
            (click)="onEditEvent(row)"
          >
            Edit
          </button>
        </div>
      }
      @if (expanded) {
        <div class="none md-block datatable-body-cell-label-actions">
          <a
            class="action-icon"
            href="javascript:void(0);"
            title="Cancel"
            (click)="onCloseRow(row)"
          >
            <span dsContent [contentPath]="'shared.cancel'"></span>
            <i class="icon-times-circle"></i>
          </a>
        </div>
      }
    </div>
  }
  <ds-alert-modal
    [config]="deletePendingPaymentModalConfig"
    (primaryEvent)="removePendingPayment(row)"
    (tertiaryEvent)="cancel()"
  >
    @if ((dataLoading | async) && !actionInFlight) {
      <ds-localized-spinner
        class="block pad-bottom-20"
        [dataLoading]="dataLoading | async"
        [loadingMessage]="loadingMsgText"
      ></ds-localized-spinner>
    }
  </ds-alert-modal>
</ng-template>
